/**
 * @fileoverview server-side DataTable GET handler for the
 * "/companies/:company_id/mobile_app_linking_assignable_tracking_domains" endpoint.
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdMobileAppLinkingAssignableTrackingDomains } from "./constants";
import type {
  GetCompaniesCompanyIdMobileAppLinkingAssignableTrackingDomainsParams,
  GetCompaniesCompanyIdMobileAppLinkingAssignableTrackingDomainsResult,
} from "./types";
import { isGetCompaniesCompanyIdMobileAppLinkingAssignableTrackingDomainsResult } from "./validators";

export const getDataTableCompaniesCompanyIdMobileAppLinkingAssignableTrackingDomains =
  reactQueryTableFetcherAdapter(
    companiesCompanyIdMobileAppLinkingAssignableTrackingDomains,
    (
      signal: AbortSignal,
      {
        companyId,
        query = {},
        limit = 20,
        start = 0,
        sortby,
        sortdir,
      }: GetCompaniesCompanyIdMobileAppLinkingAssignableTrackingDomainsParams
    ): Promise<GetCompaniesCompanyIdMobileAppLinkingAssignableTrackingDomainsResult> => {
      return fetch(
        `/companies/${companyId}/mobile_app_linking_assignable_tracking_domains`,
        "GET",
        { start, limit, sortby, sortdir, query: serializeQueryObjects(query) },
        { signal }
      );
    },
    isGetCompaniesCompanyIdMobileAppLinkingAssignableTrackingDomainsResult
  );
